<template>
    <v-dialog v-model="showDialog" max-width="900" persistent>
        <v-card>
            <v-card-actions>
                <v-btn color="primary" text @click="upload" class="text-capitalize"><v-icon>ios_share</v-icon>{{
                    $t('proceedToUpload') }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="close" class="text-capitalize">{{ $t('close') }}</v-btn>
            </v-card-actions>
            <v-card-text>
                <v-container class="px-0">
                    <v-data-table :headers="headersCsvUsers" :items="itemsCsvUsers" class="elevation-1">
                    </v-data-table>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'CsvUsers',
    data() {
        return {
            headersCsvUsers: [
                { text: this.$t('name'), value: 'fullName' },
                { text: this.$t('email'), value: 'email' },
                { text: this.$t('status'), value: 'uploadText' },
            ],
            itemsCsvUsers: [],
        }
    },
    methods: {
        close() {
            this.$store.dispatch('user/setCsvListShow', false)
            this.$store.dispatch('user/setCsvBatchId', '')
        },
        upload() {
            this.$store.dispatch('dashboard/applyLoading')
            this.$store.dispatch('user/saveCsvUsers', this.$store.getters['user/csvBatchId'])
                .then((response) => {
                    this.$store.dispatch('dashboard/cancelLoading')
                    if (response.status == 200) {
                        this.$store.dispatch('user/setCsvListShow', false)
                        this.$store.dispatch('user/setCsvBatchId', '')
                        this.$store.dispatch('user/setRefreshUserList', true)
                        this.$root.$emit('message_from_parent_long', this.$t(response.data.responseMsg))
                    } else if (response.status == 202) {
                        this.$root.$emit('message_from_parent_long', this.$t(response.data.responseMsg))
                    }
                })
                .catch((err) => {
                    this.$router.push({ name: 'NoInternet' })
                    console.log(err)
                })
        },
        initialize() {
            this.$store.dispatch('dashboard/applyLoading')
            this.$store.dispatch('user/fetchCsvUsers', this.$store.getters['user/csvBatchId'])
                .then((response) => {
                    //console.log(response.data)
                    this.$store.dispatch('dashboard/cancelLoading')
                    this.itemsCsvUsers = response.data
                })
                .catch((err) => {
                    this.$router.push({ name: 'NoInternet' })
                    console.log(err)
                })
        },
    },
    computed: {
        showDialog() {
            return this.$store.getters['user/csvListShow']
        }
    },
    created() {
        this.initialize()
    }
}
</script>